import React, { useState } from 'react';
import { CalendarClock, ChevronDown, Loader2 } from 'lucide-react';
import { Popover, PopoverContent, PopoverTrigger } from '../../ui/popover';

const at9 = (d) => { const x = new Date(d); x.setHours(9, 0, 0, 0); return x; };
const addDays = (n) => { const d = new Date(); d.setDate(d.getDate() + n); return at9(d); };
const nextMonday = () => { const d = new Date(); d.setDate(d.getDate() + ((8 - d.getDay()) % 7 || 7)); return at9(d); };
const toLocalInput = (d) => new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 16);
export const fmtWhen = (iso) => new Date(iso).toLocaleString(undefined, { weekday: 'short', month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' });

export const SchedulePicker = ({ onPick, disabled, busy, label = 'Send later', initial }) => {
  const [open, setOpen] = useState(false);
  const [custom, setCustom] = useState(initial ? toLocalInput(new Date(initial)) : toLocalInput(addDays(1)));
  const quick = [['Tomorrow 9:00 AM', addDays(1)], ['In 3 days, 9:00 AM', addDays(3)], ['Next Monday 9:00 AM', nextMonday()]];
  const pick = (d) => { if (d.getTime() <= Date.now()) return; onPick(d.toISOString()); setOpen(false); };
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" disabled={disabled} className="h-8 px-3 rounded-full border border-neutral-300 text-xs text-neutral-700 hover:bg-neutral-100 disabled:opacity-40 inline-flex items-center gap-1.5" data-testid="compose-send-later">
          {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <CalendarClock className="w-3.5 h-3.5" />}{label}<ChevronDown className="w-3 h-3 opacity-60" />
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-64 p-2 space-y-1 z-[80]" data-testid="schedule-picker">
        <p className="px-1 text-[10px] font-semibold uppercase tracking-wider text-neutral-400">Schedule send</p>
        {quick.map(([l, d]) => (
          <button key={l} type="button" onClick={() => pick(d)} className="w-full text-left px-2 py-1.5 rounded-md text-xs hover:bg-amber-50 flex justify-between" data-testid={`schedule-quick-${l.split(' ')[0].toLowerCase()}`}>
            <span>{l}</span><span className="text-neutral-400">{d.toLocaleDateString(undefined, { month: 'short', day: 'numeric' })}</span>
          </button>
        ))}
        <div className="border-t border-neutral-100 pt-2 px-1 space-y-1.5">
          <p className="text-[11px] text-neutral-500">Pick date &amp; time</p>
          <input type="datetime-local" value={custom} min={toLocalInput(new Date())} onChange={(e) => setCustom(e.target.value)} className="w-full h-8 rounded-md border border-neutral-200 px-2 text-xs" data-testid="schedule-custom-input" />
          <button type="button" onClick={() => custom && pick(new Date(custom))} className="w-full h-7 rounded-md bg-neutral-900 text-white text-xs hover:bg-neutral-800" data-testid="schedule-custom-confirm">Schedule</button>
        </div>
      </PopoverContent>
    </Popover>
  );
};

export default SchedulePicker;
